/**
 * `device_info` block. Read at snapshot time, not at init time — keeps
 * viewport responsive to window resizes.
 */

import type { DeviceInfoBlock } from '../types.js';

const MOBILE_RE = /Mobi|Android.*Mobile|iPhone|iPod|Windows Phone|BlackBerry/i;
const TABLET_RE = /iPad|Tablet|Android(?!.*Mobile)/i;

function inferDeviceType(
  userAgent: string,
  viewportWidth: number
): 'desktop' | 'tablet' | 'mobile' {
  if (TABLET_RE.test(userAgent)) return 'tablet';
  if (MOBILE_RE.test(userAgent)) return 'mobile';
  // Viewport fallback: if the UA didn't say but the screen is small.
  if (viewportWidth > 0 && viewportWidth < 768) return 'mobile';
  return 'desktop';
}

export function readDeviceInfo(): DeviceInfoBlock {
  // We're guaranteed to be in a browser-like env (jsdom in tests). Defensive
  // reads only against truly missing globals; otherwise we fail loud per the
  // SDK rules.
  const nav = typeof navigator !== 'undefined' ? navigator : undefined;
  const win = typeof window !== 'undefined' ? window : undefined;

  const userAgent = nav?.userAgent ?? '';
  const language = nav?.language ?? '';
  const platform = nav?.platform ?? '';
  const viewport_w = win?.innerWidth ?? 0;
  const viewport_h = win?.innerHeight ?? 0;

  return {
    user_agent: userAgent,
    viewport_w,
    viewport_h,
    language,
    platform,
    device_type: inferDeviceType(userAgent, viewport_w),
  };
}
